import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import AIAnswerBlock from './components/AIAnswerBlock';
import Process from './components/Process';
import MidPageCTA from './components/MidPageCTA';
import WhyUs from './components/WhyUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <AIAnswerBlock />
      <Process />
      <MidPageCTA />
      <WhyUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
